import * as _ from 'underscore';

export type MenuItemTypes =
    | 'submenu'
    | 'ws'
    | 'divider'
    | 'favorites'
    | 'recent'
    | 'myFolder'
    | 'dirBrowser'
    | 'folderws'
    | 'all';

export const SUBMENU = 'submenu';
export const WORKSPACE = 'ws';
export const DIVIDER = 'divider';
export const FAVORITES = 'favorites';
export const RECENT = 'recent';
export const MY_FOLDER = 'myFolder';
export const DIR_BROWSER = 'dirBrowser';
export const FOLDERWS = 'folderws';
export const BROWSE_ALL = 'all';

export interface IMenuItem {
    id: number;
    type: MenuItemTypes;
    name: string;
    parent?: number;
    refId?: number;
    level?: number;
    isExpanded?: boolean;
}

export interface IMenuBranch extends IMenuItem {
    items?: (IMenuItem | IMenuBranch)[];
}

export interface ICustomMenuValue {
    menu: IMenuItem[];
    hideMenuItemIcons?: boolean;
    expandMenuOnMouseOver?: boolean;
    treeMode: TreeModes;
    name?: string;
    namedMenus?: ICustomMenuValue[];
    groupID?: number;
}

export enum MenuModes {
    sideBar = 0,
    horizontal = 1
}

export enum TreeModes {
    flat = 0,
    tree = 1
}

export interface IMenuItemData {
    icon: string;
    title?: string;
}

export const MenuItemsData: {
    [type: string]: IMenuItemData;
} = {
    submenu: {
        icon: 'glyphicon glyphicon-folder-open',
        title: 'Submenu'
    },

    favorites: {
        icon: 'glyphicon glyphicon-star',
        title: 'Favorites'
    },

    recent: {
        icon: 'glyphicon glyphicon-time',
        title: 'Recent'
    },

    myFolder: {
        icon: 'glyphicon glyphicon-home',
        title: 'My Folder'
    },

    ws: {
        icon: 'glyphicon glyphicon-th-large'
    },

    dirBrowser: {
        icon: 'glyphicon glyphicon-folder-close'
    },

    folderws: {
        icon: 'glyphicon glyphicon-gift'
    },

    divider: {
        icon: 'glyphicon glyphicon-minus',
        title: 'Divider'
    },

    all: {
        icon: 'glyphicon glyphicon-hdd',
        title: 'Browse'
    }
};

export function findMenuItems(
    menu: IMenuBranch[],
    predicate: (menuItem: IMenuBranch) => boolean,
    result?: IMenuBranch[]
): IMenuBranch[] {
    if (menu == null) {
        return;
    }

    if (result == null) {
        result = [];
    }

    _.each(menu, (menuItem) => {
        if (predicate(menuItem)) {
            result.push(menuItem);
        } else {
            findMenuItems(menuItem.items, predicate, result);
        }
    });

    return result.length > 0 ? result : null;
}
